module.exports = __webpack_public_path__ + "static/media/troopr-jira-configure-app-link.54b4c36d.png";